<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";
import store from "@/store";

import {
  getRequestsScheme as fetchData,
  postRequestsScheme as updateData,
} from "@/api/approval";
import defaultScheme from "@/api/schemes/approval";
import { enumUserRoles, enumUserRolesAdminRegion } from "@/utils/filters";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";

const updateScheme = async (scheme) => {
  try {
    const { roles } = scheme.properties;
    const isAdminRegion =
      store.getters.roles?.length && store.getters.roles[0] === "adminregion";
    const items = isAdminRegion ? enumUserRolesAdminRegion : enumUserRoles;

    Object.assign(roles, {
      items,
      params: { key: "id", label: "name", multiple: true },
    });
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        async updateData(state, data) {
          data.roles = data.roles.map((r) => r.id);
          await updateData(state, data);
          this.$router.back();
        },
        updateScheme,
      },
    };
  },
};
</script>
